import { getProductAndPlanFromSku } from '~/product-catalog/utils/get-utils';
import type { ProductAllowance } from '~/subscription-management/api/common/model/subscription';
import type {
  OrganizationListItem,
  SiteItem,
} from '~/subscription-management/features/service-resource-list/hooks/useServiceResourceList';

export const updatedProductsForSite = (
  site: SiteItem,
  updatedProducts: ProductAllowance[],
): ProductAllowance[] => {
  return updatedProducts.filter((updated) => updated.entity.entityIdentifier === site.id);
};

const hasChangedProducts = (site: SiteItem, updatedProducts: ProductAllowance[]): boolean => {
  const updatedSiteProducts = updatedProductsForSite(site, updatedProducts);

  return site.products.some((siteProduct) =>
    updatedSiteProducts.some((updated) => {
      const { product } = getProductAndPlanFromSku(updated.sku);
      return (
        product.id === siteProduct.effectiveNow.product.id &&
        updated.sku !== siteProduct.effectiveNow?.allowance.sku
      );
    }),
  );
};

export const sitesHaveActiveChanges = (
  sites: SiteItem[],
  updatedProducts: ProductAllowance[],
): boolean => {
  return sites.some((site) => hasChangedProducts(site, updatedProducts));
};

export const orgsHaveActiveChanges = (
  orgs: OrganizationListItem[],
  updatedProducts: ProductAllowance[],
): boolean => {
  return orgs.some((org) => sitesHaveActiveChanges(org.sites, updatedProducts));
};
